export default "__VITE_ASSET__D6HtUfJb__"